export default __webpack_public_path__ + "static/media/SLIDER_IMAGEN_VERDE.0eda3a32.jpg";